import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {GameSectionSkillService} from '../../../services/games/game-section-skill/game-section-skill.service';
import {GameSkillItemComponent} from '../../../components/games/skills/game-skill-item/game-skill-item.component';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';

@Component({
  selector: 'app-games-section-skills',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    GameSkillItemComponent,
    SpinnerComponent
  ],
  templateUrl: './games-section-skills.component.html',
  styleUrls: ['./games-section-skills.component.scss']
})
export class GamesSectionSkillsComponent implements OnInit {

  @Input() section: any;

  loader = true;
  skills: any;

  constructor(
    private activeModal: NgbActiveModal,
    private sectionSkillSrv: GameSectionSkillService
  ) {
  }

  async ngOnInit() {
    this.skills = await this.sectionSkillSrv.findAllBySection(this.section.uniqid);
    this.loader = false;
  }

  trackById(index: number, item: any) { return item.id; }

  close() {
    this.activeModal.close();
  }

}
